import styled from "styled-components";
import {PrimaryButton} from "../../../../basic-components/buttons/primary-button";
import React from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../../hooks/use-services.hook";
import {PriceComponent} from "../../../../components/price/price.component";
import {
    ICardMethodViewModel
} from "../../../../services/booking/models/payment/methods/card/card-method.view-model.interface";


const PayButton = styled(PrimaryButton)`
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: ${props => props.theme.fontSize.h4};
    gap: ${props => props.theme.spacing.spacing8};
    white-space: nowrap;
`

export const StandardCardPayButtonComponent: React.FC<{cardMethod: ICardMethodViewModel}> = observer((props) => {
    const services = useServices();

    const onPayButtonClick = async () => {
        await props.cardMethod.startPayment();
    }

    return (
        <PayButton onClick={onPayButtonClick} fullWidth={true}>
            <span>
                {services.language.translate('Pay')}
            </span>
            <PriceComponent price={props.cardMethod.amount}/>
        </PayButton>
    );
})